import { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { FaInstagram, FaFacebook } from 'react-icons/fa'; 
import '../assets/css/page/contact.css';

const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{"Kadi's Hair Gallery - Contact Us"}</title>
        </Helmet>
      </HelmetProvider>

      <section className='main-contact' id='contact'>
        <div>
          <h2 data-aos="fade-zoom">Contact</h2>

          {/* MAIN FLEX CONTAINER */}
          <div id='contact-us' className='container'>

            {/* LEFT COLUMN */}
            <div className='contact-column left'>
              <h3 className='h3' data-aos="fade-left">Store Information</h3>
              <hr />
              {/* Two columns for store hours */}
              <div className="store-hours-container">
                <div className="store-column">
                    <strong>Kadi's Hair Gallery</strong> <br />
                    <strong>Business Hours:</strong> <br />
                        Monday: 10am - 5pm <br />
                        Tuesday: 9am - 9pm <br />
                        Wednesday: 9am - 9pm <br />
                        Thursday: 9am - 9pm <br />
                        Friday: 9am - 9pm <br />
                        Saturday: 8am - 5pm <br />
                        Sunday: Closed <br />
                </div>

                <div className="store-column">
                    <strong>Kadi's Hair Gallery 2</strong> <br />
                    <strong>Business Hours:</strong> <br />
                        Monday: 9am - 7pm <br />
                        Tuesday: 9am - 7pm <br />
                        Wednesday: 9am - 7pm <br />
                        Thursday: 9am - 7pm <br />
                        Friday: 9am - 7pm <br />
                        Saturday: 8am - 5pm <br />
                        Sunday: Closed <br />
                    </div>
                </div>

                <div className="follow-us">
                    <strong>Follow Us</strong>
                    <br />
                    <div className="social-icons">
                        <a
                            href="https://www.instagram.com/kadishairgallery/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <FaInstagram />
                        </a>
                        
                        <a
                            href="https://www.facebook.com/kadishairgallery/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                        >
                            <FaFacebook />
                        </a>
                    </div>
                </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className='contact-column right'>
              <h3 className='h3' data-aos='fade-right'>Call Us</h3>
              <hr />

              <div className='contact-call-section'>
                <h4>Need to Book or Ask a Question?</h4>
                <p>We’d love to hear from you! Give us a call during business hours at the numbers below:</p>

                <div className='phone-numbers'>
                  <p><strong>📞 Kadi’s Hair Gallery 1:</strong> <a href="tel:7034903112">(703) 490-3112</a></p>
                  <p><strong>📞 Kadi’s Hair Gallery 2:</strong> <a href="tel:5714919196">(571) 491-9196</a></p>
                </div>

                <p className='call-hours'>Available during business hours listed on the left.</p>

                <div className='call-buttons'>
                  <a href="tel:7034903112" className="call-btn">Call Location 1</a>
                  <a href="tel:5714919196" className="call-btn">Call Location 2</a>
                </div>
              </div>
            </div>
          </div>

          {/* MAPS */}
          <div className='maps-container'>
            <div className='location1-map'>
              <h4>Location 1 – Woodbridge, VA</h4>
              <iframe
                title="Kadi's Hair Gallery Location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3191180.8666582485!2d-77.30122874836948!3d38.63996798437784!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6566cc84fe667%3A0x36c3ab9431294c53!2sKadi's%20Hair%20Gallery!5e0!3m2!1sen!2sus!4v1712335583165!5m2!1sen!2sus"
                width="90%"
                height="200"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className='location2-map'>
              <h4>Location 2 – Woodbridge, VA (Richmond HWY)</h4>
              <iframe
                title="Kadi's Hair Gallery 2 Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3116.8102972181114!2d-77.27539792500922!3d38.630244971782346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b655f0e7deba6b%3A0xbb7021f8cac425c8!2sKadi's%20Hair%20Gallery%202!5e0!3m2!1sen!2sus!4v1712336736934!5m2!1sen!2sus"
                width="90%"
                height="200"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
